import { Box, Typography } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';

function CantoDecorativo({ posicao }) {
  const base = { position: 'absolute', width: 22, height: 22, borderColor: '#e94560' };
  const porPosicao = {
    'top-left':     { top: -1, left: -1, borderTop: '2px solid', borderLeft: '2px solid' },
    'top-right':    { top: -1, right: -1, borderTop: '2px solid', borderRight: '2px solid' },
    'bottom-left':  { bottom: -1, left: -1, borderBottom: '2px solid', borderLeft: '2px solid' },
    'bottom-right': { bottom: -1, right: -1, borderBottom: '2px solid', borderRight: '2px solid' },
  };
  return <Box sx={{ ...base, ...porPosicao[posicao] }} />;
}

export default function CartaoAutenticacao({ children }) {
  return (
    <Box
      sx={{
        position: 'relative', zIndex: 1,
        width: '100%', maxWidth: 380,
        m: { xs: 2, md: 0 }, mr: { md: 10 },
        backgroundColor: 'rgba(255,255,255,0.93)',
        backdropFilter: 'blur(22px)',
        borderRadius: 2,
        border: '1px solid rgba(255,255,255,0.4)',
        boxShadow: '0 30px 80px rgba(0,0,0,0.5)',
        p: { xs: 3.5, md: 4.5 },
        mt: { xs: 32, md: 0 },
      }}
    >
      <style>{`
        @keyframes pulseDot {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.35; }
        }
        @media (prefers-reduced-motion: reduce) {
          .ponto-status { animation: none !important; }
        }
      `}</style>

      <CantoDecorativo posicao="top-left" />
      <CantoDecorativo posicao="top-right" />
      <CantoDecorativo posicao="bottom-left" />
      <CantoDecorativo posicao="bottom-right" />

      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.9, mb: 2.5 }}>
        <Box
          className="ponto-status"
          sx={{ width: 6, height: 6, borderRadius: '50%', backgroundColor: '#16A34A', animation: 'pulseDot 2s ease-in-out infinite' }}
        />
        <Typography sx={{ fontSize: 10, fontFamily: 'monospace', letterSpacing: '0.14em', color: '#94a3b8', fontWeight: 700, textTransform: 'uppercase' }}>
          Acesso seguro
        </Typography>
      </Box>

      {children}

      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.6, justifyContent: 'center', mt: 3 }}>
        <LockOutlinedIcon sx={{ fontSize: 12, color: '#cbd5e1' }} />
        <Typography sx={{ fontSize: 10.5, color: '#94a3b8', fontFamily: 'monospace' }}>
          Conexão criptografada
        </Typography>
      </Box>
    </Box>
  );
}